
export class DeliveryNotExecutedDTO{
    public Comment?: string = undefined;
}